<div class="col-md-12">
    <div class="assign-section">
      <div class="col-md-4">
        <mat-form-field appearance="none" class="form-control search-div">
          <input matInput placeholder="Search by Coder Name" [(ngModel)]="searchKey" (keyup)="getAssignmentQueueListData()"
            #input>
          <button mat-button matSuffix mat-icon-button arai-label="Clear" *ngIf="searchKey" (click)="onSearchClear()"
          class="mat-icon-button">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button mat-raised-button class="btn Action-buttons" *ngIf="!searchKey" (click)="getAssignmentQueueListData()" style="background-color: transparent; border: none; z-index:1;
                  box-shadow: 0 0 black;
                  position: absolute;
                  left: 275px;
                  top: 12px;">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <div class="col-md-4"></div>
      <div class="col-md-4 search-bx-outer">
        <div class="schedule-div1">
          <button mat-raised-button class="btn btn-icon-text3 act-btn" [disabled]="isManageCoderDisabled"
            (click)="openManageCoder()">
            <i class="fa fa-check-square" aria-hidden="true"></i> &nbsp; Manage Coder</button>
        </div>
      </div>
    </div>
</div>

<div class="col-lg-12 grid-margin stretch-card paddrl35" style="padding-bottom: 20px;">
<div class="card Member-card">
  <table mat-table matSort [dataSource]="dataSource" aria-label="Elements" class="display nowrap mat-elevation-z0" style="width:100%"
  name="search">

  <ng-container matColumnDef="radioButton" class="radio-button-click">
    <mat-radio-group appearance="fill">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let row">
        <mat-radio-button [value]="row" (click)="radiobuttonClick($event, row)" color="primary">
        </mat-radio-button>

      </td>
    </mat-radio-group>
  </ng-container>


  <!-- Member Name Column -->
  <ng-container matColumnDef="coderName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Coder Name</th>
    <td mat-cell *matCellDef="let coderQueue"> {{coderQueue.coderName}} </td>
  </ng-container>

  <ng-container matColumnDef="userId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>User Id</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.userId}}</td>
  </ng-container>
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.email}}</td>
  </ng-container>
  <ng-container matColumnDef="phoneNumber">
    <th mat-header-cell *matHeaderCellDef>Phone</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.phoneNumber}}</td>
  </ng-container>

  <ng-container matColumnDef="coderLevel">
    <th mat-header-cell *matHeaderCellDef>Coder Level</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.coderLevel}}</td>
  </ng-container>

  <ng-container matColumnDef="qaNeeded">
    <th mat-header-cell *matHeaderCellDef>QA Needed</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.qaNeeded}}</td>
  </ng-container>
  <ng-container matColumnDef="clientNames">
    <th mat-header-cell *matHeaderCellDef>Assigned Clients</th>
    <td mat-cell *matCellDef="let coderQueue" [innerHtml]="coderQueue.clientNames.split(',').join(', <br/>')"> </td>
  </ng-container>
  <ng-container matColumnDef="projectNames">
    <th mat-header-cell *matHeaderCellDef>Assigned Projects</th>
    <td mat-cell *matCellDef="let coderQueue" [innerHtml]="coderQueue.projectNames.split(',').join(', <br/>')"> </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>Status</th>
    <td mat-cell *matCellDef="let coderQueue">{{coderQueue.status}} </td>
  </ng-container>
  <ng-container matColumnDef="loading">
    <mat-footer-cell *matFooterCellDef colspan="6"
      style="position: absolute; text-align: center; width: 100%;"> </mat-footer-cell>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>

</table>

 <mat-paginator #paginator [showFirstLastButtons]="true" [length]="length" [pageSize]="pageSize"
   [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
   (page)="pageEvent = getAssignmentQueueListData($event)" class="mat-paginator-sticky">
 </mat-paginator>
</div>

</div>
